import { render, staticRenderFns } from "./SkeletonText.vue?vue&type=template&id=bf29ccfa&scoped=true&"
import script from "./SkeletonText.vue?vue&type=script&lang=js&"
export * from "./SkeletonText.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonText.vue?vue&type=style&index=0&id=bf29ccfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf29ccfa",
  null
  
)

export default component.exports